// Single source of truth for "is this a dev session?". Returns true ONLY
// when the URL contains `?dev=1`. Used to gate the netcode profiler HUD,
// the home-screen Dev Mode toggle, and the in-game FPS / position
// readouts so neither players nor devs-on-localhost see them by default.
// Opt in explicitly with `?dev=1` when you actually want the diagnostic
// overlays.

let cached: boolean | null = null;

export function isDevMode(): boolean {
  if (cached !== null) return cached;
  if (typeof window === 'undefined') { cached = false; return cached; }
  cached = new URLSearchParams(window.location.search).has('dev');
  return cached;
}
